import { useContext } from 'react'
import { SupportUsersContext } from 'contexts'
import { SupportUser } from '../api'
import {
  SupportUserSpreadPermissions,
  checkAllSupportUserPermissions,
} from './useSupportUserApi'

const spreadPermissions = (
  supportUser: SupportUser,
): SupportUserSpreadPermissions => ({
  ...supportUser,
  id: supportUser.id,
  ...checkAllSupportUserPermissions(supportUser),
})

export const useSupportUsers = () => {
  const { state, dispatch } = useContext(SupportUsersContext)

  return {
    supportUsers: state.supportUsersList,
    supportUsersContext: state,
    lastApiReceiveAt: state.loadingState.lastApiReceiveAt,
    dispatch,
    spreadPermissions,
  }
}
